@if (!uiSettings()?.mobileEmbed) {
  <app-header></app-header>
  <div class='govpl-spacer'></div>
}
<main>
  <div class='main-container'>
    <ng-content></ng-content>
  </div>
</main>
@if (!uiSettings()?.mobileEmbed) {
  <app-footer>
  </app-footer>
}
